import discordLogo from "../../media/discord-logo2.png";
import twitterLogo from "../../media/twitter-logo.png";
import instagramLogo from "../../media/instagram-logo3.png";
import mkLogo from '../../media/mk-logo.png';

import '../../css/mk-brand.css';

import {useState, useEffect} from "react";

function JoinCommunityPanel() {
    const [isPlaying, setIsPlaying] = useState(false);
    const toggle = () => setIsPlaying(!isPlaying);
    useEffect(() => {}, [isPlaying]);
    return (
        <div id="join-community-panel" className="quarter-panel">
            <table>
                <tbody>
                <tr>
                    <td><img src={mkLogo} className="logo" onClick={toggle}  /></td>
                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</td>
                    <td>
                        <p className="title">Join our community</p>
                        <table>
                            <tbody>
                            <tr className="">
                                <td><a href="https://discord.gg/metakitchen" target="_blank" ><img src={discordLogo} className="social-logo" alt="connect to us on Discord" /></a></td>
                                <td>&nbsp;&nbsp;&nbsp;</td>
                                <td><a href="https://twitter.com/meta_Kitchen" ><img src={twitterLogo} className="social-logo" alt="follow us on twitter" /></a></td>
                                <td>&nbsp;&nbsp;&nbsp;</td>
                                <td><a href="https://instagram.com/metakitchennft" ><img src={instagramLogo} className="social-logo" alt="follow us on Facebook" /></a></td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}

export default JoinCommunityPanel;

